<template>
	<div class="wrapper">
		<div class="top">
			<span>支付宝校园刷脸支付</span>
			<span>诚邀有资源的伙伴共享刷脸支付红利</span>
		</div>
		<h3>K12刷脸支付</h3>
		<div class="short_stub">
			<div></div>
			<div></div>
		</div>
		<div class="" style="display: flex;flex-direction: row;	height: 100%;align-items: center;">
			<img src="../assets/pay/img1.png" style="width: 2.083333rem;height: 1.5625rem;" />
			<span style="width: 2.5rem;height: 1.041666rem;
			background-color: rgba(48, 110, 255, 1);
			font-size: 0.104166rem;color: #FFFFFF;text-align: left;
			line-height: 0.208333rem;
			padding: 0.260416rem 0.3125rem;">知会云携手支付宝将人脸支付与K12校园就餐、超市购物等场景结合，学生刷脸扣家长支付宝，无需充值，对账便捷，减少人力、财力投入，家长可实时查看学生在校消费信息，实现无现金校园，打造更便捷的校园生活。
			</span>
		</div>

		<h3>刷脸支付优势</h3>
		<div class="short_stub">
			<div></div>
			<div></div>
		</div>
		<div class="yoush_wrapper">
			<div class="youshi_c">
				<div class="youshi_i">
					<img src="../assets/pay/2.jpg" />
					<span>无丢卡、盗刷隐患</span>
				</div>
				<div class="youshi_i" style="margin-left: 1.020833rem;">
					<img src="../assets/pay/3.jpg" />
					<span>无需线下充值，较少人力投入</span>
				</div>
			</div>
			<div class="youshi_c">
				<div class="youshi_i">
					<img src="../assets/pay/4.jpg" />
					<span>支付宝代扣，无需充值，无需排队</span>
				</div>
				<div class="youshi_i" style="margin-left: 1.020833rem;">
					<img src="../assets/pay/5.jpg" />
					<span>家长可实时掌握孩子的消费信息</span>
				</div>
			</div>
			<div class="youshi_c">
				<div class="youshi_i">
					<img src="../assets/pay/6.jpg" />
					<span>资金安全，使用便捷</span>
				</div>
				<div class="youshi_i" style="margin-left: 1.020833rem;">
					<img src="../assets/pay/1.jpg" />
					<span>无现金校园，减少不必要的纠纷</span>
				</div>
			</div>
		</div>

		<h3>合作模式</h3>
		<div class="short_stub">
			<div></div>
			<div></div>
		</div>
		<div class="demo_wrapper">

			<div class="corp">

				<img src="../assets/pay/p1.png" class="corp-icon" />
				<span>厂家垫资建设</span>

			</div>
			<div class="corp">
				<img src="../assets/pay/p3.png" class="corp-icon" />
				<span>合作伙伴0投入</span>
			</div>
			<div class="corp">
				<img src="../assets/pay/p2.png" class="corp-icon" />
				<span>分润丰厚</span>
			</div>
		</div>


		<h3>加盟要求</h3>
		<div class="short_stub">
			<div></div>
			<div></div>
		</div>
		<div class="remand_wrapper">
			<div class="remand">
				<img src="../assets/pay/img1.png" class="remand-icon" />
				<span>有意向投身教育领域的创业者或者实干家</span>
			</div>
			<div class="remand">
				<img src="../assets/pay/img2.png" class="remand-icon" />
				<span>充满热情的教育领域或者教育服务行业的从业者</span>
			</div>
			<div class="remand">
				<img src="../assets/pay/img3.png" class="remand-icon" />
				<span>拥有校园资源，期望快速变现的行业人士</span>
			</div>
		</div>


		<div class="zixun_c">
			<span class="zixun_c_title">欢迎咨询合作</span>
			<span class="zixun_c_d">
				如有疑问或合作意向，请留下您的姓名和联系电话，我们将尽快联系您
				<br />您也可直接致电免费热线：400-138-9808
			</span>
			<form action>
				<div class="form_t">
					<div class="form_t_i">
						<span>姓名</span>
						<input type="text" v-model="formMess.name" />
					</div>
					<div class="form_t_i">
						<span>手机（必填）</span>
						<input type="phone" maxlength="11" v-model="formMess.phone" />
					</div>
					<div class="form_t_i">
						<span>邮箱</span>
						<input type="email" v-model="formMess.email" />
					</div>
				</div>
				<div class="form_problem">
					<span>问题描述</span>
					<textarea type="text" v-model="formMess.problem" />
					</div>
			</form>
			<button class="btn_submit" @click="submit">提交</button>
		</div>
	</div>
	
	
</template>

<style scoped>
	
	.remand {
		background: #F6F6F6;
		display: flex;flex-direction: column;align-items: center;width: 1.979166rem;
		margin-left:0.15625rem ;
	}
	.remand_wrapper {
		display: flex;
		flex-direction: row;
		margin: 0 1.875rem;
		margin-bottom: 0.625rem;
	}
	.remand span {
		height: 0.458333rem;
		font-size: 0.145833rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #091630;
		line-height: 0.229166rem;
		text-align: left;
		margin-left: 0.15625rem;
		margin-top: -0.052083rem;
	}
	.remand-icon {
		width: 1.979166rem;height: 2.5rem;
	}
	
	.corp-icon {
		width: 0.75rem;height: 0.75rem;
	}
	
	.corp {
		display: flex;align-items: center;flex-direction: column;color: #FFFFFF;font-size: 0.166666rem;justify-content: center;
		background: linear-gradient(90deg, #FFCF74 0%, #FF7D3F 100%);width: 1.666666rem;height: 1.666666rem;border-radius: 0.833333rem;
	}
	.corp span {
		line-height: 0.229166rem;color: rgb(255,255,255,0.9);
	}
	
	.vjs-big-play-button {
		left: 50% !important;
		top: 50% !important;
		margin-left: -2em;
		margin-top: -1.3em;
	}

	.school_c {
		display: flex;
		align-items: center;
		display: -webkit-flex;
		justify-content: space-between;
		flex-direction: row;
		flex-wrap: wrap;
		margin-bottom: 0.3125rem;
	}

	.school_c:after {
		content: "";
		width: 1.942708rem;
	}

	.school_i_n {
		width: 1.942708rem;
		height: 1.041667rem;
		background: rgba(255, 255, 255, 1);
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-around;
		margin-bottom: 0.208333rem;
	}

	.school_i_n img {
		width: 0.208333rem;
		height: 0.192708rem;
		opacity: 0.5;
	}

	.school_i_n span {
		font-size: 0.104167rem;
		font-weight: 600;
		color: rgba(0, 0, 0, 1);
		line-height: 0.104167rem;
	}

	.school_i_p {
		width: 1.942708rem;
		height: 1.145833rem;
		background: rgba(255, 255, 255, 1);
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-around;
		margin-bottom: 0.15625rem;
		box-shadow: 0px .15625rem .46875rem -.104167rem rgba(63, 110, 240, 0.2);
	}

	.school_i_p img {
		width: 0.208333rem;
		height: 0.192708rem;
	}

	.school_i_p span {
		font-size: 0.104167rem;
		font-weight: 600;
		color: rgba(0, 0, 0, 1);
		line-height: 0.104167rem;
	}

	.dingwei {
		width: 100%;
		height: 2.578125rem;
		background: rgba(47, 110, 240, 1);
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-top: 0.208333rem;
	}

	.dingwei_d {
		width: 3.125rem;
		font-size: .083333rem;
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
		line-height: .125rem;
		text-align: left;
	}

	.dingwei_c {
		display: flex;
		align-items: center;
		margin-top: 0.260417rem;
	}

	.dingwei_c_c {
		position: relative;
		width: 3.385417rem;
		height: 3.385417rem;
		background: rgba(255, 255, 255, 0.05);
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 0 0.911458rem;
	}

	.dingwei_c_s {
		width: 2.5rem;
		height: 2.5rem;
		background: rgba(255, 255, 255, 0.1);
		border-radius: 50%;
	}

	.dingwei_c_c img {
		position: absolute;
		width: 2.140625rem;
		height: 2.953125rem;
	}


	.demo_wrapper {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.demo_wrapper div:nth-child(2) {
		margin-left: -0.204166rem;
	}

	.demo_wrapper div:nth-child(3) {
		margin-left: -0.204166rem;
	}

	.situation {
		display: flex;
		flex-direction: row;
		width: 6.25rem;
	}

	.situation_video,
	.situation_remark {
		width: 3.125rem;
	}

	.situation_remark {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	}

	.remark {
		width: 2.083333rem;
		height: 0.520833rem;
		background: #3875F6;
	}

	.left::before {
		content: '';
		width: 0;
		height: 0;
		border: 0.15625rem solid transparent;
		border-bottom: 0.104166rem solid #3875F6;
		top: 0.052083rem;
		left: -0.416666rem;
		position: relative;
		pointer-events: none;
	}

	.right::after {
		content: '';
		width: 0;
		height: 0;
		border: 0.15625rem solid transparent;
		border-bottom: 0.104166rem solid #3875F6;
		top: 0.052083rem;
		right: -0.416666rem;
		position: relative;
		pointer-events: none;
	}

	.remark span {
		line-height: 0.520833rem;
		font-size: 0.208333rem;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		position: relative;
	}

	.left span {
		left: -0.15625rem;
	}

	.right span {
		right: -0.15625rem;
	}


	.yoush_wrapper {
		margin-top: 0.145833rem;
	}

	.youshi_c {
		display: flex;
		align-items: center;
		justify-content: space-between;
		/* flex-wrap: wrap; */
		margin-top: 0.208333rem;
		width: 5rem;
		margin: 0.208333rem 2.5rem 0.208333rem 2.5rem;
	}

	.youshi_i {
		display: flex;
		width: 50%;
		flex-direction: row;
		align-items: center;
	}

	.youshi_i img {
		width: 0.3125rem;
		height: 0.3125rem;
	}

	.youshi_i span {
		margin-left: 0.208333rem;
		font-size: 0.104166rem;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #091630;
	}



	/* .fade-enter-active, .fade-leave-active {
	transition: all 1s ease;
}
.fade-enter, .fade-leave-to	{
	transform:translateY(-200px);
	opacity: 0;
} */

	.wrapper {
		width: 100%;
		display: -webkit-box;
		/* OLD - iOS 6-, Safari 3.1-6 */
		display: -moz-box;
		/* OLD - Firefox 19- (buggy but mostly works) */
		display: -ms-flexbox;
		/* TWEENER - IE 10 */
		display: -webkit-flex;
		/* NEW - Chrome */
		display: flex;
		/* NEW, Spec - Opera 12.1, Firefox 20+ */
		/* 09版 */
		-webkit-box-orient: vertical;
		/* 12版 */
		-webkit-flex-direction: column;
		-moz-flex-direction: column;
		-ms-flex-direction: column;
		-o-flex-direction: column;
		flex-direction: column;
		/* 09版 */
		-webkit-box-align: center;
		/* 12版 */
		-webkit-align-items: center;
		-moz-align-items: center;
		-ms-align-items: center;
		-o-align-items: center;
		align-items: center;
	}

	.top {
		width: 100%;
		height: 2.604167rem;
		background: url("//static.h5.ylmob.com/website/img/face2pay.png") no-repeat;
		background-size: 100% 100%;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;
	}

	.top span:nth-child(1) {
		font-size: 0.3125rem;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
		line-height: 0.3125rem;
		margin-left: 1.880208rem;
	}

	.top span:nth-child(2) {
		font-size: 0.15625rem;
		font-weight: 400;
		color: rgba(255, 255, 255, 0.75);
		line-height: 0.15625rem;
		margin-top: 0.15625rem;
		margin-left: 1.880208rem;
	}

	.banner {
		width: 100%;
	}
	
	.zixun_c {
		width: 100%;
		height: 4.010417rem;
		background: url(//static.h5.ylmob.com/website/img/shangwu_bottom.png)
			no-repeat;
		background-size: 100% 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.zixun_c_title {
		font-size: 0.208333rem;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
		line-height: 0.3125rem;
		margin-top: 0.416667rem;
	}
	.zixun_c_d {
		font-size: 0.083333rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
		line-height: 0.125rem;
		margin-top: 0.104167rem;
	}
	.form_t {
		width: 5.208333rem;
		justify-content: space-between;
		display: flex;
		align-items: center;
		margin-top: 0.3125rem;
	}
	.form_t_i {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
	}
	.form_t_i span {
		font-size: 0.083333rem;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: rgba(255, 255, 255, 1);
		line-height: 0.083333rem;
		margin-bottom: 0.083333rem;
	}
	.form_t_i input {
		outline-style: none;
		width: 1.666667rem;
		height: 0.3125rem;
		border: 1px solid rgba(255, 255, 255, 0.8);
		background-color: transparent;
		padding: 0.0625rem;
		box-sizing: border-box;
		font-size: 0.083333rem;
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
		caret-color: rgba(255, 255, 255, 1);
	}
	.form_problem {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		margin-top: 0.208333rem;
	}
	.form_problem span {
		font-size: 0.083333rem;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: rgba(255, 255, 255, 1);
		line-height: 0.083333rem;
		margin-bottom: 0.083333rem;
	}
	.form_problem textarea {
		outline-style: none;
		width: 5.208333rem;
		height: 0.78125rem;
		border: 1px solid rgba(255, 255, 255, 0.8);
		background-color: transparent;
		padding: 0.0625rem;
		box-sizing: border-box;
		font-size: 0.083333rem;
		line-height: 0.125rem;
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
		caret-color: rgba(255, 255, 255, 1);
	}
	.btn_submit {
		width: 1.041667rem;
		height: 0.3125rem;
		border: 0px;
		outline: none;
		background: rgba(63, 110, 240, 1);
		border-radius: 0.229167rem;
		margin-top: 0.416667rem;
		color: rgba(255, 255, 255, 1);
		font-size: 0.104167rem;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
	}
	.btn_submit:hover {
		background: rgb(42, 93, 231);
	}
	
</style>


<script>
	// @ is an alias to /src
	import http from '../utils/http.js';
	export default {
		name: "Face2Pay",
		components: {},
		data() {
			return {
				
				formMess: {
				name: "",
				phone: "",
				email: "",
				problem: ""
				},
				checkdata: [
				{
					inspect: "", // 待检测的字段
					msg: "姓名" // 空值返回的提示
				},
				{
					inspect: "",
					msg: "手机号",
					reg: "^[1][3,4,5,7,8][0-9]{9}$"
				},
				{
					inspect: "",
					msg: "邮箱",
					reg:
					"^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"
				},
				{
					inspect: "",
					msg: "问题描述"
				}
				],
				
				schoolList: [
					"来宾市第十一中学",
					"良江初级中学",
					"嵊州初级中学",
					"余姚市姚北实验学校",
					"杭州建德新世纪实验学校",
				],
				hoverIndex: 0,
				showIndex: -1
			};
		},

		methods: {
			showHover(index) {
				this.hoverIndex = index;
			},
			assignData() {
				//赋值
				var arrForm = [];
				for (let key in this.formMess) {
					arrForm.push(key);
				}
				for (let i = 0; i < this.checkdata.length; i++) {
					var key = arrForm[i];
					this.checkdata[i].inspect = this.formMess[key];
				}
				return arrForm;
			},
			
			submit() {
					this.assignData();
					var end = this.have_empty(this.checkdata);
					if (!end) return; // 判定验证结果
					http.syncTime(this.formMess).then(res => {
					console.log(res);
					this.$alert("提交成功", "提示", {
							confirmButtonText: "确定",
					});
					}).catch(error => {
							// 权限访问异常
							console.log(error);
					});
			}
		},
		mounted() {}
	};
</script>
